var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import { animated, useSpring } from 'react-spring';
var StyledPanel = styled(animated.div)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  min-height: 100%;\n  max-height: 100%;\n  width: 350px;\n  background-color: #fff;\n  box-shadow: 1px 1px 2px #ddd;\n  display: flex;\n  transform: translate3d(-100%, 0, 0);\n"])));
export default function Panel(_ref) {
  var className = _ref.className,
      open = _ref.open,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "open"]);

  var styles = useSpring({
    x: open ? 0 : -350
  });
  return /*#__PURE__*/React.createElement(StyledPanel, _extends({
    className: clsx('panel', className),
    style: _extends({}, styles, {
      visibility: styles.x.interpolate(function (x) {
        return x > -350 ? 'visible' : 'hidden';
      })
    })
  }, props));
}